import { render, staticRenderFns } from "./FacturaShowData.vue?vue&type=template&id=4804f342&"
import script from "./FacturaShowData.vue?vue&type=script&lang=js&"
export * from "./FacturaShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports